import Vue from 'vue'
import axios from 'axios'
import floatIcon from '@/components/LevelTest/Report/floatIcon'
Vue.use(axios)
import rating1Icon from "@/assets/rating/happy 1-1.png";
import rating2Icon from "@/assets/rating/happy 1-2.png";
import rating3Icon from "@/assets/rating/happy 1-3.png";
import rating4Icon from "@/assets/rating/happy 1-4.png";
import rating5Icon from "@/assets/rating/happy 1.png";

export default {
    name: 'feedbackform',
    components: {
        floatIcon
    },
    data: () => {
        return {
            rating1: 0,
            rating2: 0,
            rating3: 0,
            rating4: 0,
            next: 1,
            prev: 0,
            rate1: 0,
            rate2: 0,
            rate3: 0,
            rate4: 0,
            message: null,
            StudentData: null,

            sad1out: true,
            sad1: false,
            thinking1out: true,
            thinking1: false,
            happy1out: true,
            happy1: false,
            smile1out: true,
            smile1: false,
            love1out: true,
            love1: false,

            sad2out: true,
            sad2: false,
            thinking2out: true,
            thinking2: false,
            happy2out: true,
            happy2: false,
            smile2out: true,
            smile2: false,
            love2out: true,
            love2: false,

            sad3out: true,
            sad3: false,
            thinking3out: true,
            thinking3: false,
            happy3out: true,
            happy3: false,
            smile3out: true,
            smile3: false,
            love3out: true,
            love3: false,

            sad4out: true,
            sad4: false,
            thinking4out: true,
            thinking4: false,
            happy4out: true,
            happy4: false,
            smile4out: true,
            smile4: false,
            love4out: true,
            love4: false,
            ratingIcons: [
                rating1Icon,
                rating2Icon,
                rating3Icon,
                rating4Icon,
                rating5Icon
            ],
        }
    },
    mounted() {
        axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=' + this.$route.params.l_id + '&action=studentInfo')
            //.then(response=>console.warn(response.data))
            .then(response => this.StudentData = response.data)
    },
    watch: {
        rating1() {

            this.rate1 = this.rating1
        },
        rating2() {

            this.rate2 = this.rating2
        },
        rating3() {

            this.rate3 = this.rating3
        },
        rating4() {

            this.rate4 = this.rating4
        }
    },
    computed: {
        feedBack() {
            return {

                l_id: this.StudentData.l_id,
                payload: [{
                    Q1: this.rate1
                }, {
                    Q2: this.rate2
                }, {
                    Q3: this.rate3
                }, {
                    Q4: this.rate4
                }],
                suggestion: this.message

            }
        },
        prevbtn() {
            if (this.next > 1 && this.next != 6) {
                return true
            } else return false
        },
        nxtbtn() {
            if (this.next != 5 && this.next != 6) {
                return true
            } else return false
        }
    },
    methods: {
        nextrate() {
            if (this.next == 1 && this.rating1 > 0) {
                this.next++
            } else if (this.next == 2 && this.rating2 > 0) {
                this.next++
            } else if (this.next == 3 && this.rating3 > 0) {
                this.next++
            } else if (this.next == 4 && this.rating4 > 0) {
                this.next++
            }

        },
        nextslide(val) {
            if (val == 1) {
                return this.prev = 2, this.next = 1

            } else if (val == 2) {
                if (this.rate1 > 0) {

                    if (this.prev >= 3) {
                        return this.next = 2, this.prev = 3
                    } else if (this.prev <= 2) {
                        return this.next = 2, this.prev = 2
                    }

                }

            } else if (val == 3) {
                if (this.rate2 > 0) {
                    if (this.prev >= 4) {
                        return this.next = 3, this.prev = 4
                    } else if (this.prev <= 3) {
                        return this.next = 3, this.prev = 3
                    }

                }

            } else if (val == 4) {
                if (this.rate3 > 0) {
                    if (this.prev >= 5) {
                        return this.next = 4, this.prev = 5
                    } else if (this.prev <= 4) {
                        return this.next = 4, this.prev = 4
                    }
                }

            } else if (val == 5) {
                if (this.rate4 > 0) {

                    return this.next = 5, this.prev = 4

                }

            }

        },
        sad1Click() {
            this.rate1 = 1

            this.sad1out = false
            this.sad1 = true

            this.thinking1out = true
            this.thinking1 = false
            this.happy1out = true
            this.happy1 = false
            this.smile1out = true
            this.smile1 = false
            this.love1out = true
            this.love1 = false

        },
        thinking1Click() {
            this.rate1 = 2
            this.thinking1out = false
            this.thinking1 = true

            this.sad1out = true
            this.sad1 = false
            this.happy1out = true
            this.happy1 = false
            this.smile1out = true
            this.smile1 = false
            this.love1out = true
            this.love1 = false
        },
        happy1Click() {
            this.rate1 = 3
            this.happy1out = false
            this.happy1 = true

            this.sad1out = true
            this.sad1 = false
            this.thinking1out = true
            this.thinking1 = false
            this.smile1out = true
            this.smile1 = false
            this.love1out = true
            this.love1 = false
        },
        smile1Click() {
            this.rate1 = 4
            this.smile1out = false
            this.smile1 = true

            this.sad1out = true
            this.sad1 = false
            this.thinking1out = true
            this.thinking1 = false
            this.happy1out = true
            this.happy1 = false
            this.love1out = true
            this.love1 = false
        },
        love1Click() {
            this.rate1 = 5
            this.love1out = false
            this.love1 = true

            this.sad1out = true
            this.sad1 = false
            this.thinking1out = true
            this.thinking1 = false
            this.happy1out = true
            this.happy1 = false
            this.smile1out = true
            this.smile1 = false
        },

        sad2Click() {
            this.rate2 = 1
            this.sad2out = false
            this.sad2 = true

            this.thinking2out = true
            this.thinking2 = false
            this.happy2out = true
            this.happy2 = false
            this.smile2out = true
            this.smile2 = false
            this.love2out = true
            this.love2 = false
        },
        thinking2Click() {
            this.rate2 = 2
            this.thinking2out = false
            this.thinking2 = true

            this.sad2out = true
            this.sad2 = false
            this.happy2out = true
            this.happy2 = false
            this.smile2out = true
            this.smile2 = false
            this.love2out = true
            this.love2 = false
        },
        happy2Click() {
            this.rate2 = 3
            this.happy2out = false
            this.happy2 = true

            this.sad2out = true
            this.sad2 = false
            this.thinking2out = true
            this.thinking2 = false
            this.smile2out = true
            this.smile2 = false
            this.love2out = true
            this.love2 = false
        },
        smile2Click() {
            this.rate2 = 4
            this.smile2out = false
            this.smile2 = true

            this.sad2out = true
            this.sad2 = false
            this.thinking2out = true
            this.thinking2 = false
            this.happy2out = true
            this.happy2 = false
            this.love2out = true
            this.love2 = false
        },
        love2Click() {
            this.rate2 = 5
            this.love2out = false
            this.love2 = true

            this.sad2out = true
            this.sad2 = false
            this.thinking2out = true
            this.thinking2 = false
            this.happy2out = true
            this.happy2 = false
            this.smile2out = true
            this.smile2 = false
        },

        sad3Click() {
            this.rate3 = 1
            this.sad3out = false
            this.sad3 = true

            this.thinking3out = true
            this.thinking3 = false
            this.happy3out = true
            this.happy3 = false
            this.smile3out = true
            this.smile3 = false
            this.love3out = true
            this.love3 = false
        },
        thinking3Click() {
            this.rate3 = 2
            this.thinking3out = false
            this.thinking3 = true

            this.sad3out = true
            this.sad3 = false
            this.happy3out = true
            this.happy3 = false
            this.smile3out = true
            this.smile3 = false
            this.love3out = true
            this.love3 = false
        },
        happy3Click() {
            this.rate3 = 3
            this.happy3out = false
            this.happy3 = true

            this.sad3out = true
            this.sad3 = false
            this.thinking3out = true
            this.thinking3 = false
            this.smile3out = true
            this.smile3 = false
            this.love3out = true
            this.love3 = false
        },
        smile3Click() {
            this.rate3 = 4
            this.smile3out = false
            this.smile3 = true

            this.sad3out = true
            this.sad3 = false
            this.thinking3out = true
            this.thinking3 = false
            this.happy3out = true
            this.happy3 = false
            this.love3out = true
            this.love3 = false
        },
        love3Click() {
            this.rate3 = 5
            this.love3out = false
            this.love3 = true

            this.sad3out = true
            this.sad3 = false
            this.thinking3out = true
            this.thinking3 = false
            this.happy3out = true
            this.happy3 = false
            this.smile3out = true
            this.smile3 = false
        },

        sad4Click() {
            this.rate4 = 1
            this.sad4out = false
            this.sad4 = true

            this.thinking4out = true
            this.thinking4 = false
            this.happy4out = true
            this.happy4 = false
            this.smile4out = true
            this.smile4 = false
            this.love4out = true
            this.love4 = false
        },
        thinking4Click() {
            this.rate4 = 2
            this.thinking4out = false
            this.thinking4 = true

            this.sad4out = true
            this.sad4 = false
            this.happy4out = true
            this.happy4 = false
            this.smile4out = true
            this.smile4 = false
            this.love4out = true
            this.love4 = false
        },
        happy4Click() {
            this.rate4 = 3
            this.happy4out = false
            this.happy4 = true

            this.sad4out = true
            this.sad4 = false
            this.thinking4out = true
            this.thinking4 = false
            this.smile4out = true
            this.smile4 = false
            this.love4out = true
            this.love4 = false
        },
        smile4Click() {
            this.rate4 = 4
            this.smile4out = false
            this.smile4 = true

            this.sad4out = true
            this.sad4 = false
            this.thinking4out = true
            this.thinking4 = false
            this.happy4out = true
            this.happy4 = false
            this.love4out = true
            this.love4 = false
        },
        love4Click() {
            this.rate4 = 5
            this.love4out = false
            this.love4 = true

            this.sad4out = true
            this.sad4 = false
            this.thinking4out = true
            this.thinking4 = false
            this.happy4out = true
            this.happy4 = false
            this.smile4out = true
            this.smile4 = false
        },
        submit() {
            // if (this.$refs.form.validate()) {
            // console.warn(this.feedBack)
            axios.post('https://phone.megatalking.com/origin/api/leveltest_review.php', this.feedBack)
                .then((result) => {
                    if (result) {
                        this.next = 6
                    }
                }).catch(error => console.log('this is the error ' + error))
                // }

        },

        submitTest() {
            this.next = 6
        }
    }
}